import React, {FC, useState} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import GatewayService from "../../service/GatewayService";
import {SellOrder} from "../../models/SellOrder";

type Props = {
}



const RowComponent: FC<SellOrder> = (so) => {
    return <>
    <tr>
        <td>{so.tradingsymbol}</td>
        <td>{so.exchange}</td>
        <td>{so.quantity}</td>
        <td>{so.price}</td>
        <td>{so.expectedProfit}</td>
    </tr>
    </>
}
const TableComponent: FC<Props> = () => {

    const [sellOrders, setSellOrders] = useState<Array<SellOrder>>([]);
    const [boughtAt, setBoughtAt] = useState(0);
    const [qty, setQty] = useState(0);
    const [interest, setInterest] = useState(15);
    const [isin, setIsin] = useState("");

    const[flag, setFlag] = useState(false);

    function findSellOrders() {
        return GatewayService.getSellOrders(boughtAt, isin, interest, qty).then(orders => setSellOrders(orders))
    }

    return <div>
        bought At = <input type="number" value={boughtAt} onChange={event => setBoughtAt(parseFloat(event.target.value))}/>
        qty = <input type="number" value={qty} onChange={event => setQty(parseInt(event.target.value))}/>
        monthly interest = <input type="number" value={interest} onChange={event => setInterest(parseFloat(event.target.value))}/>
        isin bought = <input type="text" value={isin} onChange={event => setIsin(event.target.value)}/>
        <button onClick={findSellOrders}>look sell orders</button>
        <br/>this is for following scenario
        <br/>you already bought SGB by mistake
        <br/>you are looking to sell some SGB to book profit on exchange
        <table className={"full"}>
            <thead>
            <tr>
                <th>tradingsymbol</th>
                <th>exchange</th>
                <th>quantity</th>
                <th>price</th>
                <th>expectedProfit</th>
            </tr>
            </thead>
            <tbody>
            {sellOrders.map(sellOrder => <RowComponent
                // key = {sellOrder.tradingsymbol}
                {...sellOrder}
            />)}
            </tbody>
        </table>
    </div>;
}

export default TableComponent;